require('./focusable.js');

(($) => {

    /**
     * Enables site menu functionality:
     * Focus site menu when shown
     * Return focus to opening button when site menu hides
     * Trap keyboard focus
     * Close on ESCAPE key
     *
     * @returns {jQuery}
     */
    $.fn.siteMenuCollapse = function () {

        this.each(function () {

            const siteMenu = $(this);

            const focusable = siteMenu.focusable();

            siteMenu.on('show.bs.collapse', event => {
                $(event.target).attr('aria-modal', 'true');
            });

            siteMenu.on('shown.bs.collapse', event => {
                if (siteMenu.attr('tabindex') === '0') {
                    siteMenu[0].focus();
                }
                else if (focusable.length > 0) {
                    focusable[0].focus();
                }
            });

            siteMenu.on('keyup', event => {
                if (event.key === 'Escape' || event.keyCode === 27) {
                    siteMenu.collapse('hide');
                }
            });

            siteMenu.on('hide.bs.collapse', event => {
                $(event.target).attr('aria-modal', 'false');
            });

            siteMenu.on('hidden.bs.collapse', event => {
                const id = $(event.target).attr('id');
                if (id) {
                    const controller = $(`[aria-controls="${id}"]`);
                    if (controller.length > 0) {
                        controller[0].focus();
                    }
                }
            });

            focusable.on('focusout', event => {
                const focusReceiver = siteMenu.find(event.relatedTarget);
                if (focusReceiver.length === 0) {
                    event.preventDefault();
                    event.stopPropagation();
                    event.target.focus();
                }
            });

        });

        return this;
    };

})(jQuery);
